import { ArrowRight, CalendarCheck } from "lucide-react";
import { AIRBNB_URL, IMAGES } from "@/data/property";
import { Reveal, MaskLineInView } from "./Reveal";
import Availability from "./Availability";

export default function Booking() {
  return (
    <section id="availability" data-testid="booking-section" className="relative py-28 md:py-40 overflow-hidden">
      <img src={IMAGES.hero} alt="Waterfront pool at twilight" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#0A192F]/70" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 text-center">
        <Reveal>
          <span className="text-sm uppercase tracking-widest text-[#1FB6C9] font-body">Availability & Booking</span>
        </Reveal>
        <h2 className="mt-4 font-display font-semibold text-white text-4xl md:text-7xl tracking-tight leading-[0.95]">
          <MaskLineInView>Your lakeside escape</MaskLineInView>
          <MaskLineInView delay={0.1}>
            <span className="font-serif-accent italic font-normal text-[#1FB6C9]">awaits.</span>
          </MaskLineInView>
        </h2>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-xl mx-auto text-white/80 font-body text-lg">
            See live dates below and book direct — save 15% versus other platforms with Elite STR Hosting Co.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={AIRBNB_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="booking-check-dates-btn"
              className="group inline-flex items-center gap-2 rounded-full bg-[#1FB6C9] px-9 py-4 font-display font-medium text-white shadow-xl shadow-[#1FB6C9]/30 transition-transform duration-300 hover:-translate-y-1"
            >
              <CalendarCheck size={18} /> Check Dates & Book
              <ArrowRight size={18} className="cta-arrow" />
            </a>
            <a
              href="#contact"
              data-testid="booking-inquiry-btn"
              className="inline-flex items-center gap-2 rounded-full border border-white/50 px-9 py-4 font-display font-medium text-white transition-colors duration-300 hover:bg-white hover:text-[#0E2A47]"
            >
              Send an Inquiry
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-14 max-w-4xl mx-auto text-left">
            <Availability />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
